import { Component, Input, OnInit } from '@angular/core';
import { SortingColumn, SortingModel, SortingStatus } from '@domain/sorting';
import { ModalController } from '@ionic/angular';
import { SortingTypeEnum } from '@shared';
import { cloneDeep } from 'lodash';

@Component({
	selector: 'app-sorting',
	templateUrl: './sorting.component.html',
	styleUrls: ['./sorting.component.scss']
})
export class SortingComponent implements OnInit {
	@Input() public sortingModel: SortingModel;

	public sortType = SortingTypeEnum;
	public selectedSortDirection: SortingTypeEnum;
	public internalSortModel: SortingModel;

	private selectedItem: SortingColumn;

	public constructor(private modalController: ModalController) {}

	public ngOnInit(): void {
		this.internalSortModel = cloneDeep(this.sortingModel);
		this.selectedSortDirection = this.internalSortModel.sortDirection;
		this.selectedItem = this.internalSortModel.columns.find((col) => col.isSelected);
	}
	public onItemSelected(item: SortingColumn): void {
		this.internalSortModel.columns.forEach((col) => (col.isSelected = false));
		if (this.selectedItem) {
			this.selectedItem.isSelected = false;
		}
		item.isSelected = true;
		this.selectedItem = item;
	}

	public onSortDirectionSelected(sortDir: string): void {
		this.selectedSortDirection = SortingTypeEnum[sortDir];
	}

	public applyFilters() {
		this.modalController.dismiss(
			new SortingStatus({
				selectedColumn: { ...this.selectedItem },
				sortDirection: this.selectedSortDirection
			})
		);
	}
}
